import { Modal, Text, View, type GestureResponderEvent } from 'react-native';
import Translations from 'src/core/utils/Translations';
import { PrimaryButton, SecondaryButton } from 'src/presentation/components/molecules/Button';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';
import Dimens from 'src/core/utils/Dimens';
import Styles from 'src/core/utils/Styles';
import { SvgIconType } from '@thermenresorts/icons';

interface Props {
	buttonText: string;
	logoutText: string;
	onPress: (event: GestureResponderEvent) => void;
	onPressLogout?: (event: GestureResponderEvent) => void;
	visible?: boolean;
}

const LogOutDialog = ({ buttonText, logoutText, onPress, onPressLogout, visible }: Props) => {
	return (
		<Modal animationType="fade" style={dialogStyles.modalView} transparent={true} visible={visible}>
			<View style={dialogStyles.centeredView}>
				<View style={dialogStyles.modalCard}>
					<Text style={dialogStyles.modalTitle}>{Translations.areYouSureYouWantToLogout}</Text>

					<View style={Styles.row.dialogButtons}>
						<SecondaryButton extraStyle={{ flex: Dimens.flex1 }} label={buttonText} onPress={onPress} />
						<PrimaryButton
							extraStyle={{ flex: Dimens.flex1 }}
							iconSize={Dimens.iconSize21}
							label={logoutText}
							svgIcon={SvgIconType.logout}
							onPress={onPressLogout}
						/>
					</View>
				</View>
			</View>
		</Modal>
	);
};

export default LogOutDialog;
